import { useCallback, useEffect, useState } from 'react'
import { toast } from 'sonner'
import {
  gestoresService,
  type GestorJornadaDashboard,
  type GestorOneOnOneRegistro,
} from '@/services/gestoresService'
import type { JornadaCadenciaDias } from '@/components/Gestores/gestorJornadaUi'

export function useGestorJornadaTab() {
  const [data, setData] = useState<GestorJornadaDashboard | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [registrandoId, setRegistrandoId] = useState<string | null>(null)
  const [historico, setHistorico] = useState<GestorOneOnOneRegistro[]>([])
  const [historicoLoading, setHistoricoLoading] = useState(false)

  const load = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const dashboard = await gestoresService.listJornada()
      setData(dashboard)
    } catch {
      setError('Não foi possível carregar a jornada da equipe.')
      setData(null)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    void load()
  }, [load])

  const updateCadencia = useCallback(
    async (pjId: string, cadenciaDias: JornadaCadenciaDias) => {
      await gestoresService.updateJornadaCadencia(pjId, cadenciaDias)
      toast.success(`Cadência atualizada para ${cadenciaDias} dias`)
      await load()
    },
    [load],
  )

  const registerOneOnOne = useCallback(
    async (pjId: string, body: { realizadaEm: string; notas?: string }) => {
      setRegistrandoId(pjId)
      try {
        await gestoresService.registerOneOnOne(pjId, body)
        toast.success(
          body.notas?.trim()
            ? 'Reunião 1:1 registrada — anotação salva em privado'
            : 'Reunião 1:1 registrada',
        )
        await load()
      } finally {
        setRegistrandoId(null)
      }
    },
    [load],
  )

  const loadHistorico = useCallback(async (pjId: string) => {
    setHistoricoLoading(true)
    try {
      const rows = await gestoresService.listOneOnOnes(pjId)
      setHistorico(rows)
    } catch {
      toast.error('Falha ao carregar histórico de 1:1')
      setHistorico([])
    } finally {
      setHistoricoLoading(false)
    }
  }, [])

  return {
    data,
    loading,
    error,
    reload: load,
    updateCadencia,
    registerOneOnOne,
    registrandoId,
    historico,
    historicoLoading,
    loadHistorico,
  }
}
